import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import Footer from "../../components/Footer";
import CompareMain from "./CompareMain";

const Compare = () => {
  return (
    <>
      <HeaderFour />

      <CompareMain />

      <Footer />
    </>
  );
};

export default Compare;
